export default defineNuxtRouteMiddleware(() => {
	const routeUrl = useRouteUrl()
	const userStore = useUserStore()
	if (
		userStore.token &&
		userStore.user?.status === "enable" &&
		(["admin", "blogger", "support", "developer", "user"].includes(userStore.user?.type) || userStore.user?.role_id)
	) {
		return navigateTo(routeUrl.HomeUrl())
	}
})
